module.exports = __webpack_public_path__ + "media/images/close-img-f6b75cec.svg";